import { atom } from 'recoil';
import { AuthModel, AuthState } from 'models/AuthModel';

const auth = atom({
    key: 'authData',
    default: {
        lastName: 'Unknown',
        firstName: 'Llama',
        state: AuthState.Loading,
    } as AuthModel,
});

export default auth;
